import { PropTypes } from 'prop-types';
import { ReclamationType } from '../models';

const reclamationsPropTypes = {
  reclamations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.number.isRequired,
      status: PropTypes.number.isRequired,
    })
  ).isRequired,
  damageClaimOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          value: PropTypes.string,
        })
      ),
    })
  ),
  getReclamations: PropTypes.func.isRequired,
  fetchEmployees: PropTypes.func.isRequired,
  fetchSites: PropTypes.func,
  getDamageClaimOptions: PropTypes.func.isRequired,
  showDialog: PropTypes.func.isRequired,
  intl: PropTypes.shape({}).isRequired,
  deleteReclamation: PropTypes.func.isRequired,
  setFromDate: PropTypes.func.isRequired,
  setUntilDate: PropTypes.func.isRequired,
  total: PropTypes.number,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  sites: PropTypes.arrayOf(PropTypes.shape({})),
  reclamationType: PropTypes.oneOf([ReclamationType.Rewash, ReclamationType.Claim]).isRequired,
  navigationInfo: PropTypes.shape({
    path: PropTypes.string,
  }),
  fromDate: PropTypes.shape({ format: PropTypes.func }),
  untilDate: PropTypes.shape({ format: PropTypes.func }),
  dateQuery: PropTypes.shape({
    fromDate: PropTypes.string,
    untilDate: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      site: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  statusFilter: PropTypes.number.isRequired,
  typeFilter: PropTypes.number.isRequired,
  archivedFilter: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
};

export default reclamationsPropTypes;
